import { useState } from 'react'

import { CustomCellEditorProps } from 'ag-grid-react'

import { SearchSelect } from '@fortem-monorepo/react-ui'

import { ClientIdOptions } from '@/components/dropdowns/ClientIdOptions'
import { useTradeClientsQuery } from '@/react-query/queries/static'

export interface ClientIdCellEditorProps extends CustomCellEditorProps<{
  client_id: number | null
}> {}

export const ClientIdCellEditor: React.FC<ClientIdCellEditorProps> = ({
  value,
  onValueChange,
  stopEditing,
}) => {
  const [open, setOpen] = useState(true)

  const query = useTradeClientsQuery()

  return (
    <div className={'flex items-center h-full!'}>
      <SearchSelect
        className={'text-xs ag-custom-component-popup w-full min-w-auto! border-0!'}
        open={open}
        setOpen={setOpen}
        value={value?.toString()}
        options={query.data
          ?.filter((val) => !!val.value)
          .map((c) => ({
            label: c.label,
            value: c.value?.toString(),
          }))}
      >
        <ClientIdOptions
          value={value}
          clients={query.data?.filter((c) => !!c.value)}
          onSelect={(val) => {
            onValueChange(val !== null || val !== undefined ? val.value : null)
            setOpen(false)
            stopEditing()
          }}
        />
      </SearchSelect>
    </div>
  )
}
